import {
  fetchCategoryList,
  removeCategory,
  updateCategory,
  fetchSubCategoryList,
  removeSubCategory,
  updateSubCategory,
  fetchUomList,
  removeUom,
  updateUom,
  fetchCategoryGroupsList,
  removeCategoryGroups,
  updateCategoryGroups,
  fetchTemplatesList,
  updateTemplate,
  removeTemplate,
} from '../api';


export const actions = {
  getCategoryList({ commit }) {
    fetchCategoryList().then((categoryData) => {
      commit('LOAD_CATEGORY_LIST', categoryData)
    })
  },
  deleteCategory({ commit }, category) {
    removeCategory().then((category) => {
      commit('DELETE_CATEGORY', category)
    })
  },
  selectedCategory({commit}, category) {
    commit('SET_SELECTED_CATEGORY', category)
  },
  applyCategoryDetails({ commit, dispatch }, category) {
    updateCategory(category).then(() => {
      dispatch('getCategoryList')
    })
  },
  getUomList({ commit }) {
    fetchUomList().then((uomData) => {
      commit('LOAD_UOM_LIST', uomData)
    })
  },
  deleteUom({ commit }, uom) {
    removeUom().then((uom) => {
      commit('DELETE_UOM', uom)
    })
  },
  selectedUom({commit}, uom) {
    commit('SET_SELECTED_UOM', uom)
  },
  applyUomDetails({ commit, dispatch }, uom) {
    updateUom(uom).then(() => {
      dispatch('getUomList')
    })
  },
  getCategoryGroupsList({ commit }) {
    fetchCategoryGroupsList().then((categoryGroupsData) => {
      commit('LOAD_CATEGORY_GROUPS_LIST', categoryGroupsData)
    })
  },
  deleteCategoryGroups({ commit }, categoryGroup) {
    removeCategoryGroups().then((categoryGroup) => {
      commit('DELETE_CATEGORY_GROUPS', categoryGroup)
    })
  },
  selectedCategoryGroups({commit}, categoryGroup) {
    commit('SET_SELECTED_CATEGORY_GROUPS', categoryGroup)
  },
  applyCategoryGroupsDetails({ commit, dispatch }, categoryGroup) {
    updateCategoryGroups(categoryGroup).then(() => {
      dispatch('getCategoryGroupsList')
    })
  },
  getTemplatesList({ commit }) {
    fetchTemplatesList().then((templatesData) => {
      commit('LOAD_TEMPLATES_LIST', templatesData)
    })
  },
  selectedTemplate({commit}, template) {
    commit('SET_SELECTED_TEMPLATE', template)
  },
  deleteTemplate({ commit }, template) {
    removeTemplate().then((template) => {
      commit('DELETE_TEMPLATE', template)
    })
  },
  applyTemplateDetails({ commit, dispatch }, template) {
    updateTemplate(template).then(() => {
      dispatch('getCategoryGroupsList')
    })
  },

}
